import { render, staticRenderFns } from "./selectTable.vue?vue&type=template&id=6d68d3c1&scoped=true&"
import script from "./selectTable.vue?vue&type=script&lang=js&"
export * from "./selectTable.vue?vue&type=script&lang=js&"
import style0 from "./selectTable.vue?vue&type=style&index=0&id=6d68d3c1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d68d3c1",
  null
  
)

export default component.exports